import { productPath } from '@/ApiPaths';

export const productGlbUrl = (id: string): string => `${productPath}glb/${id}`;

export const productUsdzUrl = (id: string): string => `${productPath}usdz/${id}`;

/**
 * GLB URL when the product has a `.glb` and an id, else null.
 * Used by `useModelViewerDynamicZoom`. Pass `enabled=false` (e.g. modal closed) to force null.
 */
export function glbZoomSrc(
  product: { availableFormats?: string[] } | null | undefined,
  id: string | null | undefined,
  enabled = true
): string | null {
  return enabled && product?.availableFormats?.includes('.glb') && id
    ? productGlbUrl(id)
    : null;
}
